import { ProductCategory } from '@mews-commander/data-access';

export const getChildrenProductCategoryIdsFromProductCategoryId = (
    productCategoryId: string,
    productCategories: ProductCategory[]
): string[] => {
    const result: string[] = [];

    const childrenMap = productCategories.reduce(
        (acc, productCategory) => {
            const parentId = productCategory.parentCategoryId;

            if (parentId) {
                if (parentId && !acc[parentId]) {
                    return { ...acc, [parentId]: [productCategory.id] };
                }

                acc[parentId].push(productCategory.id);
            }

            return acc;
        },
        {} as Record<string, string[]>
    );

    const queue = [productCategoryId];
    while (queue.length) {
        const children = childrenMap[queue.shift() ?? ''];
        if (children) {
            result.push(...children);
            queue.push(...children);
        }
    }

    return result;
};
